import React from 'react';
import './App.css';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages';
import PrivacyPage from './pages/privacy';
import TermsPage from './pages/terms';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path='/' component={Home} exact />
        <Route path='/privacy' component={PrivacyPage} exact />
        <Route path='/terms' component={TermsPage} exact />
      </Switch>
    </Router>
  );
}

export default App;
